<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Sociétés",
          icon: "bi bi-building",
          route: "societies-index",
        },
        {
          label: "Nouvelle société",
          icon: "bi bi-building-add",
          route: "societies-create",
        },
      ],
    };
  },
};
</script>
